/**
 * Web Entry Point
 * ================
 *
 * Main entry point for the web version of Auto-Claude.
 * Initializes the web API before loading the React app.
 */

// Initialize web API before anything else
import { initializeWebAPI } from './web-api';
initializeWebAPI();

// Initialize i18n before React
import '../shared/i18n';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '../renderer/App';
import '../renderer/styles/globals.css';

// Check API health on startup
import { healthApi } from './api-client';

async function checkApiHealth(): Promise<boolean> {
  try {
    const result = await healthApi.check();
    if (result.success) {
      console.log('API health check passed');
      return true;
    }
    console.error('API health check failed:', result.error);
    return false;
  } catch (error) {
    console.error('API health check error:', error);
    return false;
  }
}

// Render loading state initially
const root = ReactDOM.createRoot(document.getElementById('root')!);

// Show loading while checking API
root.render(
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#0a0a0a',
    color: '#fff',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  }}>
    <div style={{ fontSize: '24px', marginBottom: '16px' }}>Auto-Claude Web</div>
    <div style={{ color: '#888' }}>Connecting to server...</div>
  </div>
);

// Check health and render app
checkApiHealth().then((healthy) => {
  if (healthy) {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } else {
    root.render(
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#0a0a0a',
        color: '#fff',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}>
        <div style={{ fontSize: '24px', marginBottom: '16px', color: '#ff4444' }}>
          Connection Error
        </div>
        <div style={{ color: '#888', marginBottom: '24px' }}>
          Unable to connect to Auto-Claude API server
        </div>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '12px 24px',
            fontSize: '16px',
            backgroundColor: '#333',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
          }}
        >
          Retry
        </button>
      </div>
    );
  }
});
